import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

function getYearsArray(startYear, endYear) {
  const years = [];
  for (let year = startYear; year <= endYear; year++) {
    years.push(year);
  }
  return years;
}

const currentYear = new Date().getFullYear();
const yearsArray = getYearsArray(currentYear - 5, currentYear + 5);

const quartersArray = [
  "Январь/Февраль/Март",
  "Апрель/Май/Июнь",
  "Июль/Август/Сентябрь",
  "Октябрь/Ноябрь/Декабрь",
];

const PeriodChooser = ({ setPeriod }) => {
  React.useEffect(() => {
    setPeriod({
      year: currentYear,
      quarter: 1,
    });
  }, []);

  const [year, setYear] = React.useState(currentYear);
  const [quarter, setQuarter] = React.useState(1);

  const handleYear = (event) => {
    setYear(event.target.value);
    setPeriod({
      year: event.target.value,
      quarter,
    });
  };

  const handleQuarter = (event) => {
    console.log("quarter event", event.target.value);
    setQuarter(event.target.value);
    let q = quartersArray.indexOf(event.target.value) + 1;
    setPeriod({
      year,
      quarter: event.target.value,
    });
  };

  return (
    <div style={{ marginBottom: "2rem" }}>
      <FormControl sx={{ m: 1, minWidth: 120 }}>
        <InputLabel htmlFor="grouped-select">Year</InputLabel>
        <Select
          defaultValue={currentYear}
          id="grouped-select"
          label="Year"
          onChange={handleYear}
        >
          {yearsArray.map((year) => (
            <MenuItem key={year} value={year}>
              {year}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl sx={{ m: 1, minWidth: 260 }}>
        <InputLabel htmlFor="grouped-select">Quarters</InputLabel>
        <Select
          onChange={handleQuarter}
          defaultValue={quartersArray[0]}
          id="grouped-select"
          label="Quarters"
        >
          {quartersArray.map((quarter, index) => (
            <MenuItem key={quarter} value={parseInt(index) + 1}>
              {quarter}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default PeriodChooser;
